import { FileCloud as FileCloudIcon } from "@phosphor-icons/react/FileCloud";
import { LineSegment as LineSegmentIcon } from "@phosphor-icons/react/LineSegment";
import { MapPin as MapPinIcon } from "@phosphor-icons/react/MapPin";
import { Polygon as PolygonIcon } from "@phosphor-icons/react/Polygon";
import { SquaresFour as SquaresFourIcon } from "@phosphor-icons/react/SquaresFour";

export const DataTypeIcon = {
	polygon: <PolygonIcon />,
	line: <LineSegmentIcon />,
	point: <MapPinIcon />,
	raster: <SquaresFourIcon />,
	"wms/external": <FileCloudIcon />,
};
